import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'Platform Admin Console';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts